
import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import {
	Box,
	// Typography,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
} from '@mui/material';
import { useNavigate } from "react-router-dom";
import './Home.css'
import bgImage from '../../assets/images/bg-1.jpg';
import { stringConstants } from "../../constants/stringConstants";
import { useStoreActions } from 'easy-peasy';
// import { tenantList } from '../../utils/common';

const Home = () => {
	const navigate = useNavigate();
	// const [currentEnv] = useState(process.env.REACT_APP_SENTRY_ENVIRONMENT ? process.env.REACT_APP_SENTRY_ENVIRONMENT : "dev");
  const [tenantList, setTenantList] = useState([]);
	const commonAction = useStoreActions((actions) => actions.common);

	useEffect(() => {
		commonAction.getTenantList()
			.then((response) => {
        setTenantList(response?.data?.data || []);
			})
			.catch((error) => {
				// console.error("Error fetching tenant list:", error.response);
				commonAction.setSubmitSnackbar({
					open: true,
					status: false,
					messages: error?.response?.data?.error || "Error fetching tenant list",
				});
			});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
	
	return (
		<Box style={{background: `url(${bgImage}) no-repeat center center`, 'backgroundSize': 'cover'}}>
			<Box component="section" className="headerBox" sx={{ backgroundColor: 'rgba(161, 174, 176, 0.75)' }}>
				<Grid container sx={{height: '15vh', backgroundColor: '#004E87'}} justifyContent="center" alignItems="center">					
					<Grid item size={12} style={{color: '#ffffff', padding:'16px', opacity: 0.8, textAlign: 'center'}}>Prior Authorization Tool</Grid>
				</Grid>
				<Grid container justifyContent="center" className="container" alignItems="center" direction="column" sx={{ minHeight: '78vh'}}>
					<Grid item size={{ xs: 12, sm: 4, md: 4 }}></Grid>
					<Grid item size={{ xs: 12, sm: 4, md: 4 }} style={{ opacity: 9999 }}>
						{/* <Typography variant="h6" component="h6" className="filterFormLabel" style={{fontSize: '24px', fontWeight: '400', textAlign: 'center', marginBottom: '10px', color: '#004E87'}}>
							<label>Select Your Payer</label>
						</Typography> */}
						<FormControl 
							variant="outlined"
							fullWidth
							style={{ opacity: 9999 }}
						>
							<InputLabel id="demo-simple-select-label">
								Choose Payer
							</InputLabel>
							<Select
								fullWidth
								labelId="demo-simple-select-label"
								id="demo-simple-select"
								placeholder="Choose Payer"
								label="Choose Payer"
								name="policy_shortname"
								onChange={(e) => {
									navigate(`/${e.target.value}/${stringConstants.PA_CHECK_FORM_URL}`);
								}}
							>
								<MenuItem value="sss">Select</MenuItem>
								{tenantList?.map((item) => (
									<MenuItem key={item.value} value={item.value}>
										{item.displayName}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Grid>
					<Grid item size={{ xs: 12, sm: 4, md: 4 }}></Grid>
				</Grid>
				<Grid container sx={{height: '7vh', backgroundColor: '#004E87'}} justifyContent="center" alignItems="center">					
					<Grid item size={12} style={{color: '#ffffff', padding:'16px', opacity: 0.8, textAlign: 'center'}}>Powered by Itiliti Health</Grid>
				</Grid>
				{/* <Box justifyContent="center" alignItems="center" sx={{backgroundColor: '#004E87', color: '#ffffff'}}>
					<Grid container className="container" style={{paddingTop: '3.5vh', paddingBottom: '3.5vh', textAlign: 'center', opacity: 0.8}}>
						<Grid item size={12} >Powered by Itiliti Health</Grid>
					</Grid>
				</Box> */}
			</Box>
		</Box>
	)
}

export default Home;